export default {
  //
  publicInfo: {
    //获取权限列表
    GET_AUTH_LIST: '/api/admin/getAuthList',
    //
    GET_CONFIG_INFO: '/api/admin/configInfo',
  },
  //首页
  homePage: {
    //数据概览
    GET_OVER_VIEW_DATA: '/api/admin/indexData',
    //内容审核通过数据
    GET_AUDIT_DATA: '/api/admin/histogram',
    //内容使用数据
    GET_USE_DATA: '/api/admin/materialPush',
  },
  //内容中心
  materials: {
    //推送记录
    GET_PUSH_LIST: '/api/admin/getContentPushList',
    // 获取被推送的文件
    GET_PUSH_FILES: '/api/advert/getAdvertInfo',
    // 推送素材时下拉框获取账户
    GET_PUSH_ACCOUNT_SELECT: '/api/advert/getAdvertAccount',
    // 素材推送
    PUSH: '/api/advert/pushAdvertising',
    // 推送素材时下拉框获取账户
    GET_ADVERT_ACCOUNT: '/api/advert/getAdvertAccount',
    //获取日志列表
    GET_LOG_LIST: '/api/admin/auditLogList',
  },
  //任务中心
  task: {
    //任务列表
    GET_LIST: '/api/task/list',
    //创建任务
    CREATE: '/api/task/create',
    //编辑任务
    UPDATE: '/api/task/update',
    //导出任务
    EXPORT: '/api/excel/taskExportExcel',
    //获取任务详情
    DETAIL: '/api/task/detail',
    //删除任务
    DELETE: '/api/task/delete',
    //获取用户(2制作方/3投流方)
    GET_MEMBER_LIST: '/api/task/getMember',
    //获取品牌列表
    GET_BRAND_LIST: '/api/task/getBrand',
    //任务提交审核
    SUBMIT_AUDIT: '/api/task/reviewTask',
    //获取日志列表
    GET_LOG_LIST: ' /api/task/auditLogList',
  },
  //投放中心
  publish: {
    // 投放管理-账户列表
    ACCOUNT_LIST: '/api/advert/accountList',
    //新增账户
    ADD_ACCOUNT: '/api/advert/getAuthUrl',
    //删除账户
    DEL_ACCOUNT: '/api/advert/delAccount',
    //投放数据列表
    MATERIAL_LIST: '/api/advert/materialPushLog',
    //分组管理
    group: {
      //获取所有分组
      GET_ALL_GROUPS: '/api/advert/getAllGroups',
      //根据账户id获取分组
      GET_GROUPS_BY_ACCOUNT: '/api/advert/getGroups',
      //保存分组配置
      SAVE_GROUPS: '/api/advert/addGroups',
      //关联分组
      BIND_GROUP: '/api/advert/saveGroups',
      //取消关联分组
      UN_BIND_GROUP: '/api/advert/unbindGroups',
      //根据平台获取分组
      GET_GROUP_BY_PLATFORM: '/api/advert/getGroupByPlatform'
    }
  },
  //系统配置
  systemConfig: {
    //合作方管理:
    partnerAdmin: {
      //获取合作方列表
      GET_LIST: '/api/admin/partnersList',
      //新增合作方
      ADD: '/api/admin/storePartners',
      //编辑合作方
      UPDATE: '/api/admin/storePartners',
      //获取合作方类型
      GET_TYPE_DATA: '/api/admin/getPartnersType'
    },
    // 审批流
    approvalFlow: {
      // 获取审批流列表
      GET_LIST: '/api/audit/auditList',
      // 保存/提交审批流
      SAVE: '/api/audit/store',
      // 添加审核流获取角色
      GET_AUDIT_MRMBER: '/api/audit/getMember',
      //获取配置详情
      DETAIL: '/api/audit/getConfig'
    },
    // 通知邮箱配置
    email: {
      DETAIL: '/api/admin/getEmailSetting',
      SAVE: '/api/admin/emailSetting'
    },
    //MR规范
    mrSpec: {
      GET_LIST: '/api/admin/mrList',
      ADD: '/api/admin/addMr',
      EDIT: '/api/admin/editMr',
      DEL: '/api/admin/deleteMr',
      // 获取广告点位
      GET_MATERIAL_LOCATION: '/api/admin/getMaterialLocation',
      // 通过点位获取素材类型
      GET_MATERIAL_TYPE_BY_LOCATION: '/api/admin/getMaterialTypeByLocation'
    },
    //客户管理
    division: {
      GET_LIST: '/api/admin/divisionList',
      ADD: '/api/admin/divisionAdd',
      EDIT: '/api/admin/divisionEdit',
      DEL: '/api/admin/divisionDel',
      //获取品牌
      GET_BRAND: '/api/admin/getBrandPartners',
      // 编辑用户-获取品牌树状图
      GET_DIVISION_TREE: '/api/admin/getDivisionTree'
    }
  }
}
